export const prefixHttp = (url: string) => prefix(url, 'http')
export const prefixHttps = (url: string) => prefix(url, 'https')

const prefix = (url: string, prefix: string) => {
  return url.startsWith(prefix) ? url : `${prefix}://${url}`
}
